import { useEpisodes } from "@/contexts/EpisodesContext";
import { ShareIcon } from "@/Icons";
import Button, { ButtonProps } from "@components/Button";

import { useEpisode } from "../../context";

const ShareEpisode = (props: ButtonProps) => {
  const { share } = useEpisodes();

  const episode = useEpisode();
  const { hideActions } = episode;

  if (hideActions) {
    return null;
  }

  return (
    <Button
      block
      data-testid="share-mention"
      variant="tertiary"
      type="button"
      icon={ShareIcon}
      onClick={() => share(episode)}
      {...props}
    >
      {L.MENTIONS_SHARE}
    </Button>
  );
};

export default ShareEpisode;
